import React from 'react';
import ReactDOM from 'react-dom';
import './index.css';
import reportWebVitals from './reportWebVitals';
import 'bootstrap/dist/css/bootstrap.min.css';
import GoldChart from './Components/ComponentBlock/GoldChart';
import SilverChart from './Components/ComponentBlock/SilverChart';
import GoldPerformanceChart from './Components/ComponentBlock/GoldPerformanceChart';
import SilverPerformanceChart from './Components/ComponentBlock/SilverPerformanceChart';
import AnnualPerformance from './Components/ComponentBlock/AnnualPerformance';
import RatiosChart from './Components/ComponentBlock/RatiosChart';
import GoldChange from './Components/ComponentBlock/GoldChange';
import SilverChange from './Components/ComponentBlock/SilverChange';
import PriceOfGold from './Components/ComponentBlock/PriceOfGold';
import GoldChartHtml from './Components/ComponentBlock/GoldChartHtml';
import SilverChartHtml from './Components/ComponentBlock/SilverChartHtml';
import Cmcwidget from './Components/Cmcwidget';
import Buffer from './Components/ComponentBlock/Buffer';
import RatiosChartGs from './Components/ComponentBlock/RatiosChartGs';
import RatiosChartSg from './Components/ComponentBlock/RatiosChartSg';
import RatiosChartHistory from './Components/ComponentBlock/RatiosChartHistory';
import RatiosChartHistorySilver from './Components/ComponentBlock/RatiosChartHistorySilver';
import GoldChangeCny from './Components/ComponentBlock/GoldChangeCny';

ReactDOM.render(<Buffer />, document.getElementById('buffer'));
if(window.location.href.includes("/news") || window.location.href.includes("/authors")){
    ReactDOM.render(<GoldChart />, document.getElementById('goldchart'));
}
ReactDOM.render(<GoldChange />, document.getElementById('goldchange'));
if(window.location.href.includes("/shanghai-gold-exchange-gold-price")) {
    ReactDOM.render(<GoldChangeCny />, document.getElementById('goldchangechina'));
}
else {
    ReactDOM.render(<SilverChange />, document.getElementById('silverchange'));
}

var url_split = window.location.href.split("/");
var last_element = url_split.pop();

if(window.location.href.includes("/cryptocurrency-price") && !last_element.includes('cryptocurrency-price')){
    ReactDOM.render(<Cmcwidget />, document.getElementById('cmcwidget'));
}
else if(window.location.href.includes("/cryptocurrency-price")){
    ReactDOM.render(<GoldPerformanceChart />, document.getElementById('goldperformance'));
}
else if(window.location.href.includes("/gold-price-today") && last_element !== 'gold-price-today'){
        ReactDOM.render(<GoldPerformanceChart />, document.getElementById('goldperformance'));
}
else if(window.location.href.includes("/gold-price-charts.html")){
    ReactDOM.render(<GoldChartHtml />, document.getElementById('goldcharthtml'));
    ReactDOM.render(<SilverChartHtml />, document.getElementById('silvercharthtml'));
}
else if(window.location.href.includes("/gold-price-history.html")){
    ReactDOM.render(<RatiosChartHistory />, document.getElementById('ratioschart'));
    ReactDOM.render(<GoldPerformanceChart />, document.getElementById('goldperformance'));
    ReactDOM.render(<GoldPerformanceChart />, document.getElementById('goldperformancemob'));
    ReactDOM.render(<SilverPerformanceChart />, document.getElementById('silverperformance'));
}
else if(window.location.href.includes("/spot-gold.html")){
    ReactDOM.render(<RatiosChart />, document.getElementById('ratioschart'));
    ReactDOM.render(<GoldPerformanceChart />, document.getElementById('goldperformance'));
    ReactDOM.render(<GoldPerformanceChart />, document.getElementById('goldperformancemob'));
    ReactDOM.render(<SilverPerformanceChart />, document.getElementById('silverperformance'));
}
else if(window.location.href.includes("/live-gold-price.html") || (window.location.href.includes("/gold-price-chart.html")) || (window.location.href.includes("/shanghai-gold-exchange-gold-price")) || (window.location.href.includes("/gold-stocks")) || (window.location.href.includes("/silver-stocks")) || (window.location.href.includes("/gold-etfs")) || (window.location.href.includes("/silver-etfs")) || (window.location.href.includes("/silver-price.html")) || (window.location.href.includes("/gold-price-data.html")) ) {
    ReactDOM.render(<GoldPerformanceChart />, document.getElementById('goldperformance'));
}
else if(window.location.href.includes("/inflation-adjusted-gold-price.html") || window.location.href.includes("/gold-price-advertising") || window.location.href.includes("/live-gold-prices.html") || window.location.href.includes("/gold-price-today")){
    ReactDOM.render(<GoldPerformanceChart />, document.getElementById('goldperformance'));
}

else if(window.location.href.includes("/gold-price.html") || (window.location.href.includes("/gold-price-per-gram.html")) || (window.location.href.includes("/gold-price-per-kilo.html")) || (window.location.href.includes("/silver-price-per-ounce.html")) || (window.location.href.includes("/silver-price-per-kilo.html")) || (window.location.href.includes("/spot-silver.html")) || (window.location.href.includes("/30-year-gold-price-history.html")) ){
    ReactDOM.render(<RatiosChart />, document.getElementById('ratioschart'));
    ReactDOM.render(<GoldPerformanceChart />, document.getElementById('goldperformance'));
    ReactDOM.render(<GoldPerformanceChart />, document.getElementById('goldperformancemob'));
    ReactDOM.render(<SilverPerformanceChart />, document.getElementById('silverperformance'));
}
else if(window.location.href.includes("/silver-price-history.html")) {
    ReactDOM.render(<RatiosChartHistorySilver />, document.getElementById('ratioschart'));
    ReactDOM.render(<GoldPerformanceChart />, document.getElementById('goldperformance'));
    ReactDOM.render(<GoldPerformanceChart />, document.getElementById('goldperformancemob'));
    ReactDOM.render(<SilverPerformanceChart />, document.getElementById('silverperformance'));
}

else if(window.location.href.includes("/gold-silver-ratio.html")){
    ReactDOM.render(<RatiosChartGs />, document.getElementById('ratioschart'));
    ReactDOM.render(<GoldPerformanceChart />, document.getElementById('goldperformance'));
    ReactDOM.render(<GoldPerformanceChart />, document.getElementById('goldperformancemob'));
    ReactDOM.render(<SilverPerformanceChart />, document.getElementById('silverperformance'));
}
else if(window.location.href.includes("/silver-gold-ratio.html")) {
    ReactDOM.render(<RatiosChartSg />, document.getElementById('ratioschart'));
    ReactDOM.render(<GoldPerformanceChart />, document.getElementById('goldperformance'));
    ReactDOM.render(<GoldPerformanceChart />, document.getElementById('goldperformancemob'));
    ReactDOM.render(<SilverPerformanceChart />, document.getElementById('silverperformance'));
}


else if(window.location.href.includes("/Calculators/Gold-Price-Calculators.html")){
    ReactDOM.render(<GoldChart />, document.getElementById('goldchart'));
    ReactDOM.render(<SilverChart />, document.getElementById('silverchart'));
    ReactDOM.render(<GoldPerformanceChart />, document.getElementById('goldperformance'));
    ReactDOM.render(<SilverPerformanceChart />, document.getElementById('silverperformance'));

}

else if(window.location.href.includes("/silver-price-chart.html") || window.location.href.includes("/silver-price-charts.html") ) {
    ReactDOM.render(<GoldPerformanceChart />, document.getElementById('goldperformance'));
}

else if(window.location.href.includes("/")){
    ReactDOM.render(<GoldChart />, document.getElementById('goldchart'));
    ReactDOM.render(<SilverChart />, document.getElementById('silverchart'));
    ReactDOM.render(<GoldPerformanceChart />, document.getElementById('goldperformance'));
    ReactDOM.render(<SilverPerformanceChart />, document.getElementById('silverperformance'));
    ReactDOM.render(<RatiosChart />, document.getElementById('ratioschart'));
    ReactDOM.render(<AnnualPerformance />, document.getElementById('annualperformance'));
    ReactDOM.render(<PriceOfGold />, document.getElementById('priceofgold')); 
}



// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
reportWebVitals();

